import { useState } from 'react';

export default function Gallery() {
  const [selectedImage, setSelectedImage] = useState<number | null>(null);
  const [hoveredIndex, setHoveredIndex] = useState<number | null>(null);

  const images = [
    {
      url: 'https://public.readdy.ai/ai/img_res/ca0cd5c21fc607269da4bc0e3ffa25a8.jpg',
      title: 'مجوهرات فاخرة',
      category: 'جوهرات'
    },
    {
      url: 'https://readdy.ai/api/search-image?query=Designer%20luxury%20handbag%20collection%20in%20beige%20and%20champagne%20tones%20on%20marble%20surface%2C%20high-end%20fashion%20photography%2C%20soft%20studio%20lighting%2C%20minimalist%20aesthetic%2C%20premium%20quality%2C%20elegant%20presentation%2C%20boutique%20display%20style&width=800&height=600&seq=gallery-bags-002&orientation=landscape',
      title: 'شنط مميزة',
      category: 'شنط'
    },
    {
      url: 'https://readdy.ai/api/search-image?query=Elegant%20luxury%20watch%20with%20gold%20details%20on%20soft%20taupe%20background%2C%20professional%20product%20photography%2C%20warm%20lighting%2C%20minimalist%20composition%2C%20high-end%20quality%2C%20refined%20details%2C%20premium%20presentation%2C%20sophisticated%20styling&width=600&height=700&seq=gallery-watch-003&orientation=portrait',
      title: 'ساعات راقية',
      category: 'إكسسوارات'
    },
    {
      url: 'https://readdy.ai/api/search-image?query=Luxury%20silk%20evening%20dress%20in%20champagne%20color%20on%20elegant%20boutique%20display%2C%20high-end%20fashion%20photography%2C%20soft%20natural%20lighting%2C%20minimalist%20styling%2C%20premium%20quality%2C%20refined%20presentation%2C%20sophisticated%20composition&width=600&height=700&seq=gallery-dress-004&orientation=portrait',
      title: 'أزياء فاخرة',
      category: 'ملابس'
    },
    {
      url: 'https://readdy.ai/api/search-image?query=Natural%20pearl%20earrings%20and%20luxury%20accessories%20on%20soft%20beige%20velvet%20surface%2C%20professional%20jewelry%20photography%2C%20warm%20golden%20lighting%2C%20minimalist%20composition%2C%20high-end%20quality%2C%20refined%20details%2C%20premium%20presentation&width=800&height=600&seq=gallery-accessories-005&orientation=landscape',
      title: 'إكسسوارات أنيقة',
      category: 'إكسسوارات'
    },
    {
      url: 'https://readdy.ai/api/search-image?query=Designer%20sunglasses%20and%20luxury%20leather%20goods%20on%20marble%20surface%2C%20high-end%20fashion%20photography%2C%20soft%20studio%20lighting%2C%20minimalist%20aesthetic%2C%20premium%20quality%2C%20refined%20presentation%2C%20boutique%20style&width=600&height=700&seq=gallery-sunglasses-006&orientation=portrait',
      title: 'نظارات مصممة',
      category: 'إكسسوارات'
    },
    {
      url: 'https://readdy.ai/api/search-image?query=Luxury%20diamond%20ring%20with%20elegant%20design%20on%20soft%20silk%20fabric%2C%20professional%20jewelry%20photography%2C%20warm%20champagne%20lighting%2C%20minimalist%20composition%2C%20high-end%20quality%2C%20refined%20details%2C%20premium%20presentation%2C%20close-up%20shot&width=600&height=700&seq=gallery-ring-007&orientation=portrait',
      title: 'خواتم ألماس',
      category: 'جوهرات'
    },
    {
      url: 'https://readdy.ai/api/search-image?query=Designer%20Italian%20leather%20clutch%20bag%20in%20beige%20color%20on%20marble%20surface%2C%20luxury%20fashion%20photography%2C%20soft%20studio%20lighting%2C%20minimalist%20aesthetic%2C%20premium%20quality%2C%20elegant%20presentation%2C%20high-end%20boutique%20style&width=800&height=600&seq=gallery-clutch-008&orientation=landscape',
      title: 'حقائب يد',
      category: 'شنط'
    }
  ];

  return (
    <section className="py-20 px-6 bg-white">
      <div className="max-w-7xl mx-auto">
        <div className="text-center mb-16">
          <h2 
            className="text-4xl md:text-5xl font-bold text-[#C9A88A] mb-4 animate-fade-in-up"
            style={{ fontFamily: "'Playfair Display', serif" }}
          >
            معرض الصور
          </h2>
          <div className="w-24 h-1 bg-[#D4AF7A] mx-auto mb-4 animate-scale-in"></div>
          <p className="text-[#3D3D3D]/70 text-lg max-w-2xl mx-auto animate-fade-in-up" style={{ animationDelay: '200ms' }}>
            اكتشفي جمال القطع المختارة بعناية
          </p>
        </div>

        <div className="grid md:grid-cols-2 lg:grid-cols-4 gap-4">
          {images.map((image, index) => (
            <div
              key={index}
              className={`relative overflow-hidden rounded-2xl cursor-pointer group shadow-md hover:shadow-2xl transition-all duration-500 transform hover:-translate-y-2 animate-fade-in-up ${
                index % 3 === 0 ? 'md:col-span-2 md:row-span-2' : ''
              }`}
              style={{ animationDelay: `${index * 100}ms` }}
              onClick={() => setSelectedImage(index)}
              onMouseEnter={() => setHoveredIndex(index)}
              onMouseLeave={() => setHoveredIndex(null)}
            >
              <div className={`w-full ${index % 3 === 0 ? 'h-[600px]' : 'h-[290px]'}`}>
                <img
                  src={image.url}
                  alt={image.title}
                  className={`w-full h-full object-cover object-top transition-all duration-700 ${
                    hoveredIndex === index ? 'scale-110 brightness-75' : 'scale-100'
                  }`}
                />
              </div>
              <div 
                className={`absolute inset-0 bg-gradient-to-t from-black/80 via-black/40 to-transparent transition-opacity duration-500 ${
                  hoveredIndex === index ? 'opacity-100' : 'opacity-0'
                }`}
              ></div>
              <div 
                className={`absolute bottom-0 left-0 right-0 p-6 text-white transform transition-all duration-500 ${
                  hoveredIndex === index ? 'translate-y-0 opacity-100' : 'translate-y-4 opacity-0'
                }`}
              >
                <span className="inline-block bg-[#D4AF7A] px-3 py-1 rounded-full text-xs whitespace-nowrap mb-2">
                  {image.category}
                </span>
                <h3 className="text-xl font-bold">
                  {image.title}
                </h3>
              </div>
            </div>
          ))}
        </div>

        {/* Image Modal */}
        {selectedImage !== null && (
          <div
            className="fixed inset-0 bg-black/90 z-50 flex items-center justify-center p-6 animate-fade-in"
            onClick={() => setSelectedImage(null)}
          >
            <button
              onClick={() => setSelectedImage(null)}
              className="absolute top-6 left-6 bg-white/10 backdrop-blur-sm rounded-full w-12 h-12 flex items-center justify-center hover:bg-white/20 transition-colors cursor-pointer z-10"
            >
              <i className="ri-close-line text-3xl text-white"></i>
            </button>
            
            {selectedImage > 0 && (
              <button
                onClick={(e) => {
                  e.stopPropagation();
                  setSelectedImage(selectedImage - 1);
                }}
                className="absolute right-6 top-1/2 -translate-y-1/2 bg-white/10 backdrop-blur-sm rounded-full w-12 h-12 flex items-center justify-center hover:bg-white/20 transition-colors cursor-pointer z-10"
              >
                <i className="ri-arrow-right-s-line text-3xl text-white"></i>
              </button>
            )}
            
            {selectedImage < images.length - 1 && (
              <button
                onClick={(e) => {
                  e.stopPropagation();
                  setSelectedImage(selectedImage + 1);
                }}
                className="absolute left-6 top-1/2 -translate-y-1/2 bg-white/10 backdrop-blur-sm rounded-full w-12 h-12 flex items-center justify-center hover:bg-white/20 transition-colors cursor-pointer z-10"
              >
                <i className="ri-arrow-left-s-line text-3xl text-white"></i>
              </button>
            )}

            <div 
              className="max-w-5xl w-full animate-scale-in"
              onClick={(e) => e.stopPropagation()}
            >
              <img
                src={images[selectedImage].url}
                alt={images[selectedImage].title}
                className="w-full h-auto max-h-[85vh] object-contain rounded-2xl"
              />
              <div className="text-center mt-6">
                <span className="inline-block bg-[#D4AF7A] text-white px-4 py-2 rounded-full text-sm whitespace-nowrap mb-3">
                  {images[selectedImage].category}
                </span>
                <h3 className="text-2xl font-bold text-white">
                  {images[selectedImage].title}
                </h3>
              </div>
            </div>
          </div>
        )}
      </div>

      <style>{`
        @keyframes fade-in-up {
          from {
            opacity: 0;
            transform: translateY(30px);
          }
          to {
            opacity: 1;
            transform: translateY(0);
          }
        }

        @keyframes scale-in {
          from {
            transform: scaleX(0);
          }
          to {
            transform: scaleX(1);
          }
        }

        @keyframes fade-in {
          from {
            opacity: 0;
          }
          to {
            opacity: 1;
          }
        }

        .animate-fade-in-up {
          animation: fade-in-up 0.8s ease-out forwards;
        }

        .animate-scale-in {
          animation: scale-in 0.8s ease-out forwards;
        }

        .animate-fade-in {
          animation: fade-in 0.3s ease-out forwards;
        }
      `}</style>
    </section>
  );
}
